import { render, staticRenderFns } from "./Cancella_tappa.vue?vue&type=template&id=5b4ec8c6&scoped=true&"
import script from "./Cancella_tappa.vue?vue&type=script&lang=js&"
export * from "./Cancella_tappa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4ec8c6",
  null
  
)

export default component.exports